// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.attribute_change_op */
var AttributeChangeOp;
(function (AttributeChangeOp) {
    AttributeChangeOp["CELL_UPDATE"] = "CELL_UPDATE";
    AttributeChangeOp["ROW_INSERT"] = "ROW_INSERT";
    AttributeChangeOp["ROW_DELETE"] = "ROW_DELETE";
    AttributeChangeOp["ROW_REORDER"] = "ROW_REORDER";
})(AttributeChangeOp || (AttributeChangeOp = {}));
;
export default AttributeChangeOp;
/** Zod schema for attribute_change_op */
export const attributeChangeOp = z.nativeEnum(AttributeChangeOp);
//# sourceMappingURL=AttributeChangeOp.js.map